/* tslint:disable */
/* eslint-disable */
export enum AccountType {
  SAVINGS = 'SAVINGS',
  CHECKING = 'CHECKING'
}
